import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1b37533f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "scroll-container" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "break-word" }
const _hoisted_4 = { class: "fs-7 ps-3 mt-1" }
const _hoisted_5 = { class: "fs-7 ps-2 mt-1 text-break" }
const _hoisted_6 = {
  key: 0,
  class: "fs-7 ps-2 mt-1 text-break"
}

import { PropType } from 'vue'
import UserAliasIcon from '../user-alias-icon/index.vue'


export default /*#__PURE__*/_defineComponent({
  props: {
  data: {
    type: Array as PropType<
      {
        management_no: string
        family_name: string
        given_name: string
        user_type: number | any
        display_name: string
      }[]
    >,
  },
  className: {
    type: String,
    default: '',
  },
  selectedUsers: Array,
  handleSelectUser: Function as PropType<() => void | undefined>,
  disabled: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["rounded-4 overflow-auto border-container", [__props.className]])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.data, (user, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: _normalizeClass(['d-flex px-4 py-2 item-user', __props.selectedUsers?.includes(user?.management_no) ? 'item-active' : '']),
          onClick: 
          () => {
            if (__props.disabled) {
              return
            }
            __props.handleSelectUser(user?.management_no)
          }
        
        }, [
          _createVNode(UserAliasIcon, {
            userType: user?.user_type
          }, null, 8, ["userType"]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, _toDisplayString(user?.management_no), 1),
            _createElementVNode("span", _hoisted_5, _toDisplayString(user?.family_name + ' ' + user?.given_name), 1),
            (user?.display_name)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, "（" + _toDisplayString(user?.display_name) + "）", 1))
              : _createCommentVNode("", true)
          ])
        ], 10, _hoisted_2))
      }), 128))
    ])
  ], 2))
}
}

})